(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["floating-media-columns"] && !Shopify.designMode) return;
  try {
    class FloatingMediaColumns extends HTMLElement {
    connectedCallback() {
      if (this.dataset.floatingMediaInitialized) return;
      this.dataset.floatingMediaInitialized = 'true';

      this.update = this.update.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.update();

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.querySelectorAll('[data-floating-column]').forEach((column) => this.resizeObserver.observe(column));
        this.querySelectorAll('[data-floating-inner]').forEach((inner) => this.resizeObserver.observe(inner));
      }

      this.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', this.update, { once: true });
      });
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    handleResize() {
      cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(this.update);
    }

    update() {
      this.querySelectorAll('[data-floating-column]').forEach((column) => {
        const inner = column.querySelector('[data-floating-inner]');
        if (!inner) return;
        const containerHeight = column.clientHeight;
        const contentHeight = inner.scrollHeight;
        const range = Math.max(0, contentHeight - containerHeight);
        column.style.setProperty('--float-range', `${range}px`);
      });
    }
  }

  customElements.define('floating-media-columns', FloatingMediaColumns);
  } catch(e) { console.error(e); }
})();

})();
